import type { ColorName, Spacing } from '@frontend/constants';
import type { ReactNode } from '@frontend/react';
import { Icon, XStack } from '@frontend/web-react';

export type PaywallSelectionItemProps = {
  accessibilityLabel?: string;
  bg?: ColorName;
  borderWidth?: 1 | 2;
  isSelected: boolean;
  leftContent: ReactNode;
  onClick: () => void;
  padding?: Spacing;
  rightContent?: ReactNode;
};

export const PaywallSelectionItem = ({
  accessibilityLabel,
  bg,
  borderWidth = 2,
  isSelected,
  leftContent,
  onClick,
  padding = 'md',
  rightContent,
}: PaywallSelectionItemProps) => {
  const label = accessibilityLabel ?? 'Select option';

  return (
    <XStack
      alignItems="center"
      aria-label={label}
      aria-pressed={isSelected}
      bg={bg}
      borderColor={isSelected ? 'borderSecondary' : 'borderPrimary'}
      borderWidth={borderWidth}
      className=" h-full cursor-pointer hover:border-borderSecondary"
      gapX="lg"
      onClick={onClick}
      p={padding}
      px="lg"
      radius="lg"
      role="button"
      tabIndex={0}
    >
      <Icon name={isSelected ? 'IconCircleCheckFilled' : 'IconCircle'} size={24} />
      <XStack flex={1}>{leftContent}</XStack>
      {rightContent}
    </XStack>
  );
};
